import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import OfferChoiceService from "services/OfferChoiceService";
import {AuctionType} from "constants/AuctionType";
import AuctionTypeList from "./AuctionTypeList";

const AuctionHistoryPopup = (
    {
        demandId,
        positionId,
        onClose
    }) => {


    const [auctions, setAuctions] = useState(null);

    useEffect(() => {
        OfferChoiceService.getPositionAuctions(demandId, positionId).then((resp) => {
            const {prod, test} = resp.auctions.reduce((prev, cur) => {
                if (cur.type === AuctionType.PROD)
                    prev.prod.push(cur);
                else
                    prev.test.push(cur);
                return prev;
            }, {prod: [], test: []});

            setAuctions({prod, test})
        }).catch(() => setAuctions({}))
    }, [demandId, positionId])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('close'), onClose, undefined, !auctions));
        return buttons;
    }

    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            title={Tr('auctions_information_button')}
            maxWidth='sm'
        >
            <GridBlock
                column
            >
                {!auctions ? <Loading/>
                    :
                    <div>
                        {!!auctions.prod && <AuctionTypeList auctions={auctions.prod} auctionType={AuctionType.PROD}/>}
                        <br/>
                        {!!auctions.test && <AuctionTypeList auctions={auctions.test} auctionType={AuctionType.TEST}/>}
                    </div>
                }
            </GridBlock>
        </Dialog>)
}

AuctionHistoryPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    positionId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default AuctionHistoryPopup